// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__u6aNp","logo":"style_logo__GfPP6","timer":"style_timer__wSxhH","timeInfo":"style_timeInfo__rmdfY"};